import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function SiteLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 w-full">{children}</main>
      <SiteFooter />

      <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-background-50/97 backdrop-blur border-t border-background-200 px-4 py-2.5">
        <Link
          to="/search"
          className="flex items-center justify-center gap-2 h-10 rounded-full bg-primary-700 text-background-50 text-sm font-medium cursor-pointer"
        >
          <i className="ri-search-line text-base w-4 h-4 flex items-center justify-center" />
          搜索电影 / 电视剧
        </Link>
      </div>
      <div className="lg:hidden h-16" aria-hidden="true" />
    </div>
  );
}